export default __webpack_public_path__ + "static/media/m_engineering_card17_2.09439864.png";